// Disabling the following jsdoc ESLint rules only because this code is checked by TypeScript directly
/* eslint-disable jsdoc/check-types */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable jsdoc/require-param-type */
/* eslint-disable react/jsx-no-bind */
import React, { StrictMode } from 'react';
import { ModalDialog } from 'components/ModalDialog';
import { assertNever } from 'lib/types/assert';
import {
  getInitialSignupSuccessState,
  getInitialVerifyCodeFormState,
  useHistoryState,
} from '../useHistoryState';
import { ModalHeader } from '../ModalHeader';
import { SignupForm } from '../SignupForm';
import { VerifyCodeForm } from '../VerifyCodeForm';
import { SignupSuccess } from '../SignupSuccess';
import styles from './styles.module.scss';

/**
 * Signup Modal Dialog for NBC Subs
 */
export function SignupDialog() {
  const { history, state } = useHistoryState();

  if (!state) {
    return null;
  }

  function onClose() {
    if (state?.form === 'signup') {
      window.history.back();
    } else {
      history.replaceState(undefined);
    }
  }

  let form = null;
  const currentForm = state.form;

  switch (currentForm) {
    case 'signup':
      form = (
        <SignupForm
          onSuccess={(email) => history.pushState(getInitialVerifyCodeFormState(email))}
        />
      );
      break;
    case 'verifyCode':
      form = (
        <VerifyCodeForm
          onSuccess={() => {
            history.replaceState(getInitialSignupSuccessState());
          }}
          email={state.email}
        />
      );
      break;
    case 'signupSuccess':
      form = <SignupSuccess />;
      break;
    default:
      assertNever(currentForm);
      return null;
  }

  return (
    <StrictMode>
      <ModalDialog onClose={onClose} isOpen className={styles.modal}>
        <ModalHeader onClose={onClose} />
        {form}
      </ModalDialog>
    </StrictMode>
  );
}
